import { ElementType } from "./types/elements";
import { ElementTypes } from "./constants/elements";

export const defaultAllowedTypes: ElementType[] = (
  Object.keys(ElementTypes) as ElementType[]
).filter((it) => ![ElementType.EMOJI].includes(it));
